import React from 'react'
import { keys, omit, isObject, isArray } from 'lodash'
import { Glyphicon } from 'react-bootstrap'

import { Price } from "../components/Price"
import { nameOrTitle, translateCity, getText, getTextWithTokens } from '../lib/text.js'
import { getPropTranslation, getDay, renderObject } from './LogTools.jsx'
import { ConnectedSimpleTagsList } from "../tags/TagsList"


/**
 * Aux components
 */

function getName(item, changes, propName, Activities, Cities) {
  if (propName == "agenda") {
    const { type } = item
    if (type == "activity") {
      return nameOrTitle(Activities[item.id])
    }
    else if (type == "city") {
      return `${getText("viaje_a_1")}${translateCity(Cities[item.city])}${getText("viaje_a_2")}`
    }
    else if (type == "expense") {
      const referencedExpense = item.ref && changes.filter(z => z.key == item.ref)[0]
      if (item.expense) return nameOrTitle(item.expense)
      else if (referencedExpense) return nameOrTitle(referencedExpense.expense)
      else return type
    }
    else if (type == "note") {
      return getText("Nota")
    }
    else return ""
  }
  else if (propName == "notes")  return `de ${item.author} del ${item.creation}`
  else if (propName == "routes")  return item.name || JSON.stringify(item.id)
  else return item.name || ""
}

// #TODO `getType` has an awful name
function getType(propName, changedItem) {
  const agenda = {
    activity : " la actividad ",
    expense : " el gasto ",
    city : " el transporte ",
    note : " la nota ",
    day : " el día "
  }

  if (propName == "agenda") return getText(agenda[changedItem.type])
  else if (propName == "expenses") return getText(" el gasto general ")
  else if (propName == "notes") return getText(" el comentario ")
  else if (propName == "payments") return getText(" el pago ")
  else if (propName == "routes") return getText(" la ruta ")
  else if (propName == "price") return (<Price price={changedItem} style={{ display: "inline"}} />)
  else if (propName == "tags") return (<ConnectedSimpleTagsList selectedTags={changedItem} style={{ display: "inline"}} />)
  else return `el ${changedItem.type ? changedItem.type : JSON.stringify(changedItem)} `
}


const liStyle = {}

const Change = ({entry, previous, propName, jsonDiffInstance, Activities, Cities}) => {
  /** IMPORTANTE
   * Lee esta documentación para intentar entender lo que pasa aquí:
   * https://github.com/benjamine/jsondiffpatch
   * https://github.com/benjamine/jsondiffpatch/blob/master/docs/deltas.md
   */
  const deltas = jsonDiffInstance.diff(previous, entry)

  const subchanges = (keys(omit(deltas, ['_t'])).map(key => {
    const delta = deltas[key]
    const changedItem = key.indexOf("_") == -1 ? entry[key] : previous[key.replace("_", "")]

    if (!"easyDebug") return (
      <li key={key}>
        {key}
        <ul>
          <li>delta: <code>{JSON.stringify(delta)}</code></li>
          <li>changedItem: <code>{JSON.stringify(changedItem)}</code></li>
        </ul>
      </li>
    )

    if (changedItem) {
      if (isArray(delta)) {
        // Value was added
        if (delta.length == 1) {
          return (
            <li key={key} style={liStyle}>
              <Glyphicon glyph="plus" style={{ color: "green" }} />
              {getText(" Se ha añadido ")}
              {getType(propName, changedItem)}
              {
                changedItem.type && (
                  <b> "{changedItem.type == "day" ? `${getDay(key, entry) + 1}` : getName(changedItem, entry, propName, Activities, Cities)}"</b>
                )
              }
              {changedItem.type != "day" && propName == "agenda" && getTextWithTokens(' al día $$', [getDay(key.replace("_", ""), entry)])}
            </li>
          )
        }
        // Value was deleted: delta = [ oldValue, 0, 0 ]
        else if (delta.length == 3 && delta[1] == 0 && delta[2] == 0) {
          return (
            <li key={key} style={liStyle}>
              <Glyphicon glyph="remove" style={{ color: "red" }} />
              {getText(" Se ha borrado ")}
              {getType(propName, changedItem)}
              {
                changedItem.type && (
                  <b>"{changedItem.type == "day" ? `${getDay(key.replace("_", ""), previous) + 1}` : getName(changedItem, entry, propName, Activities, Cities)}"</b>
                )
              }
              {propName == "agenda" && changedItem.type != "day" && getTextWithTokens(' del día $$', [getDay(key.replace("_", ""), previous)])}
            </li>
          )
        }
        // Array move delta = [ '', destinationIndex, 3]
        else if (delta.length == 3 && delta[2] == 3) {
          return (
            <li key={key} style={liStyle} >
              <Glyphicon glyph="sort" />
              {getText(" Se ha movido ")}
              {getType(propName, changedItem)}
              {
                changedItem.type && (
                  <b>{`"${changedItem.type == "day" ? `${getDay(key, entry) + 1}` : getName(changedItem, entry, propName, Activities, Cities)}"`}</b>
                )
              }
              {propName == "agenda" && changedItem.type != "day" && `${getTextWithTokens(' del día $$', [getDay(key.replace("_", ""), previous)])} ${getTextWithTokens(' al día $$', [getDay(delta[1], entry)])}`}
            </li>
          )
        }
      }
      else if (isObject(delta) && !isArray(delta)) { // this means its an object or array with inner changes
        const entryAgendaItem = entry[key]
        return (
          <li key={key} style={liStyle}>
            <Glyphicon glyph="pencil" style={{ color: "blue" }} />
            {getText(" Se ha modificado ")}
            {getType(propName, entryAgendaItem)}
            {<b>"{getName(entryAgendaItem, entry, propName, Activities, Cities)}"</b>}
            {propName == "agenda" && getTextWithTokens(` en el día $$:`, [getDay(key, entry)])}
            {renderObject(delta)}
          </li>
        )
      }
    }
  }))

  if (subchanges.length > 0) return (
    <div style={liStyle}>
      <li>{<b>{getPropTranslation(propName)}</b>}{getText(" se ha modificado")}: </li>
      {/* <li><code>Diff {JSON.stringify(previous)} to {JSON.stringify(entry)}</code></li> */}
      <ul key={`${propName}_sub`}>{subchanges}</ul>
      <br />
    </div>
  )
  else return null
}

export default Change
